// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g61paltV6EfimA6yqUpY{--primary: #9cff33;--primary-rgb: 156, 255, 51}", "",{"version":3,"sources":["webpack://./src/app/AppTheme.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA,CACA,2BAAA","sourcesContent":[".punch {\n  --primary: #9cff33;\n  --primary-rgb: 156, 255, 51;\n}\n"],"sourceRoot":""}]);
// Exports
export var punch = "g61paltV6EfimA6yqUpY";
export default ___CSS_LOADER_EXPORT___;
